$(document).on('turbolinks:load',function() {
  const mediaQuery = window.matchMedia('(max-width: 999px)');

  // ページが読み込まれた時に実行
  handle(mediaQuery);
    
  // ウィンドウサイズを変更しても実行（ブレイクポイントの監視）
  mediaQuery.addListener(handle);
});

function handle(mm) {
  if (mm.matches) {
    // ウィンドウサイズ999px以下のときの処理
    $(".el_sidebar_nav_inner .el_sidebar_nav_listBox:first-child").on('click', function(){
      $(this).toggleClass("is_selected");
      $(this).siblings(".sidebar_toggle_sp").slideToggle("slow");
    });
  } else {
    // それ以外の処理
    $(".sidebar_toggle_sp").removeAttr('style');
    $(".el_sidebar_nav_listBox:first-child").off();
  }
}